import { request } from '../../utils/axios';

const publicPrefix = '/public';
const sysPrefix = '/sys';

// 机构反馈评价
export const mutualEvaluation = async (data) => {
  return request.post(`${sysPrefix}/mutualEvaluation/add`, data);
};

export const getMutualEvaluationList = async (params) => {
  return request.get(`${sysPrefix}/mutualEvaluation/list`, { params });
};

// ==================== 机构实验室 ====================
export const getOrgLaboratoryList = async (params) => {
  return request.get(`${publicPrefix}/orgLaboratory/list`, { params });
};
export const addOrgLaboratory = async (data) => {
  return request.post(`${publicPrefix}/orgLaboratory/add`, data);
};
export const editOrgLaboratory = async (data) => {
  return request.post(`${publicPrefix}/orgLaboratory/edit`, data);
};
export const deleteOrgLaboratory = async (params) => {
  return request.delete(`${publicPrefix}/orgLaboratory/delete`, { params });
};
export const getOrgLaboratoryDetail = async (params) => {
  return request.get(`${publicPrefix}/orgLaboratory/view`, { params });
};

// ==================== 机构资质认定证书 ====================
export const getOrgQualityCertList = async (params) => {
  return request.get(`${publicPrefix}/checkOrgQuality/list`, { params });
};
export const addOrgQualityCert = async (data) => {
  return request.post(`${publicPrefix}/checkOrgQuality/add`, data);
};
export const editOrgQualityCert = async (data) => {
  return request.post(`${publicPrefix}/checkOrgQuality/edit`, data);
};
export const deleteOrgQualityCert = async (params) => {
  return request.delete(`${publicPrefix}/checkOrgQuality/delete`, { params });
};
export const getOrgQualityCertDetail = async (params) => {
  return request.get(`${publicPrefix}/checkOrgQuality/view`, { params });
};

// ==================== 机构从业人员 ====================
export const getStaffList = async (params) => {
  return request.get(`${publicPrefix}/staff/list`, { params });
};
export const addStaff = async (data) => {
  return request.post(`${publicPrefix}/staff/add`, data);
};
export const editStaff = async (data) => {
  return request.post(`${publicPrefix}/staff/edit`, data);
};
export const deleteStaff = async (params) => {
  return request.delete(`${publicPrefix}/staff/delete`, { params });
};
export const getStaffDetail = async (params) => {
  return request.get(`${publicPrefix}/staff/viewDetail`, { params });
};

// 从业人员证书
export const getStaffCertList = async (params) => {
  return request.get(`${publicPrefix}/staffCert/list`, { params });
};
export const addStaffCert = async (data) => {
  return request.post(`${publicPrefix}/staffCert/add`, data);
};
export const editStaffCert = async (data) => {
  return request.post(`${publicPrefix}/staffCert/edit`, data);
};
export const deleteStaffCert = async (params) => {
  return request.delete(`${publicPrefix}/staffCert/delete`, { params });
};

// 从业人员工作经历
export const getStaffWorkList = async (params) => {
  return request.get(`${publicPrefix}/staffWork/list`, { params });
};
export const addStaffWork = async (data) => {
  return request.post(`${publicPrefix}/staffWork/add`, data);
};
export const editStaffWork = async (data) => {
  return request.post(`${publicPrefix}/staffWork/edit`, data);
};
export const deleteStaffWork = async (params) => {
  return request.delete(`${publicPrefix}/staffWork/delete`, { params });
};

// 从业人员教育经历
export const getStaffEdcList = async (params) => {
  return request.get(`${publicPrefix}/staffEdc/list`, { params });
};
export const addStaffEdc = async (data) => {
  return request.post(`${publicPrefix}/staffEdc/add`, data);
};
export const editStaffEdc = async (data) => {
  return request.post(`${publicPrefix}/staffEdc/edit`, data);
};
export const deleteStaffEdc = async (params) => {
  return request.delete(`${publicPrefix}/staffEdc/delete`, { params });
};

// ==================== 机构物料管理 ====================
export const getOrgStandardsList = async (params) => {
  return request.get(`${publicPrefix}/orgStandards/list`, { params });
};
export const getOrgStandardsAggregateList = async (params) => {
  return request.get(`${publicPrefix}/orgStandards/aggregateList`, { params });
};
export const addOrgStandards = async (data) => {
  return request.post(`${publicPrefix}/orgStandards/add`, data);
};
export const editOrgStandards = async (data) => {
  return request.post(`${publicPrefix}/orgStandards/edit`, data);
};
export const deleteOrgStandards = async (params) => {
  return request.delete(`${publicPrefix}/orgStandards/delete`, { params });
};
export const getOrgStandardsDetail = async (params) => {
  return request.get(`${publicPrefix}/orgStandards/view`, { params });
};
export const removeOrgStandards = async (data) => {
  return request.post(`${publicPrefix}/orgStandards/remove`, data);
};

// 标准物质销库（出库，标记该瓶已消耗）
export const saleOrgStandards = async (id) => {
  return request.post(`${publicPrefix}/orgStandards/sale`, null, { params: { id } });
};

// 标准物质批量销库（多选证书号，聚合行操作）
export const batchSaleOrgStandards = async (ids) => {
  return request.post(`${publicPrefix}/orgStandards/batchSale`, { ids });
};

// 标准物质使用情况统计（按状态汇总，实际库存由系统按证书号统计）
export const getOrgStandardsStatistics = async (orgId) => {
  return request.get(`${publicPrefix}/orgStandards/statistics`, { params: { orgId } });
};

// ==================== 机构设备管理（检定/校准/期间核查） ====================
export const getOrgDeviceList = async (params) => {
  return request.get(`${publicPrefix}/orgDevice/list`, { params });
};
export const addOrgDevice = async (data) => {
  return request.post(`${publicPrefix}/orgDevice/add`, data);
};
export const editOrgDevice = async (data) => {
  return request.post(`${publicPrefix}/orgDevice/edit`, data);
};
export const deleteOrgDevice = async (params) => {
  return request.delete(`${publicPrefix}/orgDevice/delete`, { params });
};
export const getOrgDeviceDetail = async (params) => {
  return request.get(`${publicPrefix}/orgDevice/view`, { params });
};
export const getOrgDeviceWarningList = async (params) => {
  return request.get(`${publicPrefix}/orgDevice/warningList`, { params });
};

// ==================== 机构样品管理（每个样品每日拍照留痕） ====================
// 归属关系：样品属于机构（fkOrgId），照片属于样品（fkSampleId），照片不直接归属机构；
// photo/add 入参 fkSampleId 必填（兼容 sampleId），机构由后端按样品反查填充；
// photo/list 支持 sampleId（单样品历史）或 orgId+date（机构聚合）；
// photo/checkToday 按 sampleId 检查（旧机构口径已废弃，改用 photo/stats）。
export const getOrgSampleList = async (params) => {
  return request.get(`${publicPrefix}/orgSample/list`, { params });
};
export const addOrgSample = async (data) => {
  return request.post(`${publicPrefix}/orgSample/add`, data);
};
export const editOrgSample = async (data) => {
  return request.post(`${publicPrefix}/orgSample/edit`, data);
};
export const deleteOrgSample = async (params) => {
  return request.delete(`${publicPrefix}/orgSample/delete`, { params });
};
export const getOrgSampleDetail = async (params) => {
  return request.get(`${publicPrefix}/orgSample/view`, { params });
};
// 样品现场照片（每个样品每日拍照）
export const addOrgSamplePhoto = async (data) => {
  return request.post(`${publicPrefix}/orgSample/photo/add`, data);
};
export const getOrgSamplePhotoList = async (params) => {
  return request.get(`${publicPrefix}/orgSample/photo/list`, { params });
};

// 样品现场照片按天列表（默认从今天往前，每页N天分页）
export const getOrgSamplePhotoDailyList = async (params) => {
  return request.get(`${publicPrefix}/orgSample/photo/dailyList`, { params });
};
export const checkOrgSampleTodayPhoto = async (params) => {
  return request.get(`${publicPrefix}/orgSample/photo/checkToday`, { params });
};
// 机构今日拍照覆盖统计（total/done/undone）
export const getOrgSamplePhotoStats = async (params) => {
  return request.get(`${publicPrefix}/orgSample/photo/stats`, { params });
};